import React from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

// Pantalla de carga compartida por los visores 3D. Si `message` está
// presente (p. ej. "Generando modelo 3D…" mientras se regenera el GLB en
// Mi3DViewer.jsx) se muestra en vez de la barra de progreso.
const LoadingScreen = ({ progress = 0, title = 'Cargando modelo 3D', message }) => (
    <div className="absolute inset-0 bg-base-300/90 flex items-center justify-center z-50">
        <div className="text-center">
            <div className="relative w-24 h-24 mx-auto mb-4">
                <div className="absolute inset-0 border-4 border-base-100 rounded-full"></div>
                <div className="absolute inset-0 border-4 border-base-content/40 rounded-full border-t-transparent animate-spin"></div>
                <Cog6ToothIcon className="absolute inset-0 w-16 h-16 text-base-content/40 animate-pulse m-auto" />
            </div>
            <h3 className="text-lg font-semibold text-base-content mb-2">{title}</h3>
            {message ? (
                <p className="text-sm text-base-content/60 max-w-xs mx-auto">{message}</p>
            ) : (
                <>
                    <div className="w-64 bg-base-100 rounded-full h-2 mb-2">
                        <div
                            className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                    <p className="text-sm text-base-content/60">{Math.round(progress)}% completado</p>
                </>
            )}
        </div>
    </div>
);

export default LoadingScreen;
